import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";



export default function OurCertificate() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper container"
            >


                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/01.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/23.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/02.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/03.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/15.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/16.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/17.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/18.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/19.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/20.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/21.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/22.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/04.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/05.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/06.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/07.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/08.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/09.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/10.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/11.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/12.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/13.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5" data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <img src="assets/img/14.webp" style={{borderRadius:"5px"}} alt />
                        </div>
                    </div>
                </SwiperSlide>
                


            </Swiper>
        </>
    );
}
